import React from "react";
import { motion } from "framer-motion";
import {  Col, Button } from "react-bootstrap";
import ReportCard from "../../components/micheal/ReportCard";
import UserBarChart from "../../components/micheal/UserReport/UserBarChart";
import UserTable from "../../components/micheal/UserReport/UserTable";
import { FiUsers } from "react-icons/fi";
import { MdOutlineVerifiedUser } from "react-icons/md";
import { HiOutlineUserAdd } from "react-icons/hi";
import { FaUserSlash } from "react-icons/fa";


function UserReport() {
  const stats = [
    {
      title: "Total User",
      value: 800,
      progress: 60,
      icon: FiUsers,
      color: "#28a745",
    },
    {
      title: "Active User",
      value: 750,
      progress: 40,
      icon: MdOutlineVerifiedUser,
      color: "#ffc107",
    },
    {
      title: "New User",
      value: 100,
      progress: 50,
      icon: HiOutlineUserAdd,
      color: "#dc3545",
    },
    {
      title: "Inactive User ",
      value: 50,
      progress: 45,
      icon: FaUserSlash,
      color: "#0d6efd",
    },
  ];

  const data = [
  { month: "Jan", active: 30, inactive: 10 },
  { month: "Feb", active: 50, inactive: 20 },
  { month: "Mar", active: 60, inactive: 15 },
  { month: "Apr", active: 15, inactive: 5 },
  { month: "May", active: 40, inactive: 10 },
  { month: "Jun", active: 75, inactive: 20 },
  { month: "Jul", active: 30, inactive: 8 },
  { month: "Aug", active: 5, inactive: 2 },
  { month: "Sep", active: 65, inactive: 18 },
  { month: "Oct", active: 40, inactive: 12 },
  { month: "Nov", active: 55, inactive: 15 },
  { month: "Dec", active: 45, inactive: 10 },
];


  const users = [
  {
    name: "Antony Lewis",
    designation: "Web Designer",
    email: "antony@example.com",
    date: "14 Jan 2024",
    role: "Employee",
    status: "Active",
    avatar: "https://i.pravatar.cc/40?img=1",
  },
  {
    name: "Antony Lewis",
    designation: "Web Designer",
    email: "antony@example.com",
    date: "14 Jan 2024",
    role: "Client",
    status: "Inactive",
    avatar: "https://i.pravatar.cc/40?img=2",
  },
  {
    name: "Antony Lewis",
    designation: "Web Designer",
    email: "antony@example.com",
    date: "14 Jan 2024",
    role: "Client",
    status: "Inactive",
    avatar: "https://i.pravatar.cc/40?img=2",
  },
  {
    name: "Antony Lewis",
    designation: "Web Designer",
    email: "antony@example.com",
    date: "14 Jan 2024",
    role: "Client",
    status: "Active",
    avatar: "https://i.pravatar.cc/40?img=2",
  },
  {
    name: "Antony Lewis",
    designation: "Web Designer",
    email: "antony@example.com",
    date: "14 Jan 2024",
    role: "Client",
    status: "Inactive",
    avatar: "https://i.pravatar.cc/40?img=2",
  },
  {
    name: "Antony Lewis",
    designation: "Web Designer",
    email: "antony@example.com",
    date: "14 Jan 2024",
    role: "Client",
    status: "Active",
    avatar: "https://i.pravatar.cc/40?img=2",
  },
];

  return (
    <div className="container-fluid mt-3">

      {/* HEADER */}
      <div className="d-flex mb-3">
        <h4 className="mb-0">User Report</h4>

        <Button className="ms-auto" variant="dark" size="sm">
          Export
        </Button>
      </div>

      {/* CARDS + CHART */}
      <motion.div className="row mb-3">
        <Col md={6}>
          <ReportCard stats={stats} />
        </Col>

        <Col md={6}>
          <UserBarChart data={data} />
        </Col>
      </motion.div>

      {/* TABLE */}
      <UserTable data={users} />
    </div>
  );
}

export default UserReport;